import _ from 'lodash';
//@ts-ignore
import React, { Component } from 'react'
import { Button, 
  createStyles, 
  Dialog, 
  Theme, 
  withStyles, 
  DialogContent, 
  DialogActions, 
  WithStyles,
  Grid, 
  Tooltip } from '@material-ui/core';

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import {MyPatVideoPlayer,MyPATTextField} from './index';
import { AudioUrlImage,AudioThumbnailImage, AudioUploadImage } from  '../../constants/comman';


const styles = (theme: Theme) => createStyles({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit * 1,
    top: theme.spacing.unit * 1,
    color: theme.palette.grey[500],
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonBlue: {
    color: '#1d7dea',
  },
  audioThumnailBox: {
    border: '1px solid rgba(153, 153, 153, 0.3)',
    background: '#F5F5F5',
    borderRadius: '4px',
    height: '100%',
    padding: '10px',
    position: 'relative',
    overflow: 'hidden',
    '& img': {
        maxHeight: '100%',
        maxWidth: '80%',
        objectFit: 'cover',
        objectPosition: 'center',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
  },
  rightCol: {
    paddingLeft: '15px',
  },
  audioPlayerBox: {
    margin: '40px auto 0',
    padding: '0px 28px 1px',
    maxWidth: '460px',
    background: '#FFFFFF',
    boxShadow: '0px 0px 8px rgb(0 0 0 / 25%)',
    borderRadius: '8px',
    position: 'relative',
  },
  marginTop: {
    marginTop: 15,
  },
  PopupText: {
    fontWeight: 550
  },
  centerAlign: {
    textAlign: 'center',
  },
  customPopUpModal: {
    display: 'none',
    '&:last-child': {
      display: 'block',
    },
  },
  closeBtn: {
    marginTop: '-1px',
  }
});



interface MyPatUploadProgressProps extends WithStyles<typeof styles> {
  
  uploadPercentage:any;
  videoUrlState:any;
  handleVideoUploaded:Function,
  cancelUpload:Function,
  uploadFileObj:any,
  fileSizeBar:any,
  videoUrl: string,
  isValidUrl:any,
  addOnlyAudio: boolean;
}

interface MyPatUploadProgressState {
  open:boolean,
  progress:any
  uri:any,
 
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
  textAlign: string;
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <div >
      <div>
        <LinearProgress variant="buffer"   {...props} />
      </div>
      <div>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </div>
    </div>
  );
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, textAlign, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" className={props.textAlign === 'center' ? classes.centerAlign : ''}>{children}</Typography> 
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          {/* <CloseIcon /> */}
          <img alt="Cancel video upload" src="/assets/svg/learn/uploadCancelIcon.svg" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

class MyPatUploadProgress extends Component<MyPatUploadProgressProps, MyPatUploadProgressState> {
  constructor(props: MyPatUploadProgressProps) {
    super(props);
    const { uploadFileObj, isValidUrl} = props;
    this.state = {
      open:true,
      progress:10,
      uri: (!isValidUrl)? Object.keys(uploadFileObj).length? window.URL.createObjectURL(uploadFileObj):'':''
    }
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.cancelUpload()
  };

  

  render() {
  const { uploadPercentage, uploadFileObj, classes,fileSizeBar,videoUrl,isValidUrl} = this.props;
  return (
    <>
      <Dialog
        className={classes.customPopUpModal}
        // onClose={this.props.cancelUpload()}
        aria-labelledby="customized-dialog-title"
        open={this.state.open}
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={this.props.cancelUpload()}
          textAlign="center"
          >
          <span className={classes.PopupText}>
            Insert {this.props.addOnlyAudio ? "Audio" : "Video"}
          </span>
        </DialogTitle>

        <DialogContent>
          {!isValidUrl && (
            <div style={{ alignContent: "center" }}>
              <Grid
                container
                style={{
                  border: "solid 1px #DFDFDF",
                  padding: "18px",
                  "border-radius": "8px",
                  margin: "20px 0",
                }}
              >
                <Grid item xs={3}>
                  {this.props.addOnlyAudio ? (
                    <div className={classes.audioThumnailBox}>
                      <img src={AudioUploadImage} alt="Audio Thumbnail" />
                    </div>
                  ) : (
                    <video width="93px" height="62px" src={this.state.uri} />
                  )}
                </Grid>
                <Grid item xs={8}>
                  <div className={classes.rightCol}>
                    <Typography style={{ fontSize: "12px" }}>
                      {uploadFileObj.name}
                    </Typography>
                    <LinearProgressWithLabel
                      value={uploadPercentage}
                      style={{
                        fontSize: "12px",
                        height: "8px",
                        borderRadius: "17px",
                        color: "#666666",
                      }}
                    />
                    <div style={{ fontSize: "12px" }}>{fileSizeBar}</div>
                  </div>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" className={classes.closeBtn}>
                    <img
                      onClick={this.props.cancelUpload(uploadPercentage)}
                      alt="Cancel video upload"
                      src="/assets/svg/learn/videoUploadCancel.svg"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          )}

          {isValidUrl && (
            <>
              <Grid item xs={12}>
                {!this.props.addOnlyAudio && (
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    className={classes.marginTop}
                  >
                    <Grid item xs={1}>
                      <Typography variant="h6">URL:</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Tooltip title={videoUrl} placement="bottom-end">
                        <MyPATTextField
                          inputId="videoUrl"
                          name="videoUrl"
                          fullWidthControl
                          inputProps={{
                            required: true,
                            value: videoUrl,
                          }}
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton aria-label="close">
                        <CloseIcon onClick={this.props.cancelUpload()} />
                      </IconButton>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              {this.props.addOnlyAudio ? (
                <div className={classes.audioPlayerBox}>
                  <MyPatVideoPlayer
                    width="400px"
                    height="250px"
                    videoURL={videoUrl}
                    controls={true}
                    type="Audio"
                  />
                </div>
              ) : (
                <MyPatVideoPlayer
                  width="400px"
                  height="200px"
                  videoURL={videoUrl}
                  controls={true}
                />
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            autoFocus
            onClick={this.props.cancelUpload()}
            className={classes.buttonBlue}
          >
            Cancel
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={() => this.props.handleVideoUploaded()}
            disabled={!isValidUrl ? uploadPercentage < 100 : false}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
  }
}

//@ts-ignore
export default withStyles(styles)(MyPatUploadProgress);
